<div class="stage-container">
  <div class="tabs">
    <button class="btn-back" (click)="goBackToPipe()">Retour</button>
    <ng-container *ngFor="let tab of tabs">
      <button class="q-btn tab-button" [routerLink]="['.',tab.Route]" [routerLinkActive]="['tab-select']" (click)="OnRouting(tab)"><i [ngClass]="tab.Icon"></i>{{tab.Title}}</button>
    </ng-container>
  </div>
  <div class="px-1 px-md-4" *ngIf="StageService.Stage">
    <section id="header">
      <section [ngClass]="[displayRequiredProperties ? 'd-flex' : 'd-none']"
               id="header-btn" class="row align-items-start mb-2">
        <button class="q-btn q-main" type="button" (click)="OnSave()" placement="bottom" ngbTooltip="Enregistrer le stage">
          <i [ngClass]="[isSaving ? 'fas fa-spin fa-spinner fa-pulse' : 'fas fa-save']"></i>
        </button>

        <button class="q-btn q-danger" type="button" (click)="ConfirmModal(ModalDelete)" placement="bottom" ngbTooltip="Supprimer le stage">
          <i class="fas fa-trash-alt"></i>
        </button>

        <button class="q-btn q-main" type="button" (click)="open(ModalDuplicationStage, '')" placement="bottom" ngbTooltip="Dupliquer/Fusionner le stage">
          <i class="fas fa-clone"></i>
        </button>

        <!--<div class="checkbox checbox-switch switch-primary" placement="bottom" ngbTooltip="Mode cursus">
          <div class="q-text-m q-bold">Cursus</div>
          <label>
            <input type="checkbox" (change)="onModeCursusChange($event.target.checked)" />
            <span></span>
          </label>
        </div>-->

        <q-avatar-search class="mr-0 ml-2" mode="BUREAU" (selectedList)="OnSelectCollab($event)" [value]="[StageService.Responsable.Id]" placement="bottom" ngbTooltip="Responsable du stage"></q-avatar-search>

        <div *ngIf="!reloadRequiredProps" class="col">
          <ng-container *ngIf="cursusList">
            <q-bo-property-inline type="STRING" [property]="cursusList"></q-bo-property-inline>
          </ng-container>
          <ng-container *ngIf="StageService.Stage.Ident">
            <q-dynamictags-inline #dynamictagsInline remove-wrapper
                                  [idDonnee]="StageService.Stage.Ident"
                                  [codeOrIdBo]="'BO_STAGE'"
                                  [forcedColumnNames]="['TypsoPRO', 'Etat_PRO', 'ClotePRO']"
                                  [exceptColumnNames]="['NumstPRO', 'Info_PRO', 'DatedPRO', 'DatefPRO', 'VilleADR']"></q-dynamictags-inline>
          </ng-container>
        </div>

        <i class="fas fa-edit q-c-main mx-4 mx-md-2" (click)="open(ModalBOStage,StageService.Stage.Ident)"></i>

      </section>

      <section id="header-info" class="px-2">
        <div id="header-info-titre" class="d-flex">
          <h5 class="q-c-main"><strong>{{StageService.Stage.NumStage}} -</strong></h5>
          <h5><strong>{{StageService.Stage.Titre}}</strong></h5>
        </div>

        <div id="header-info-date" class="d-flex align-items-center">
          <div class="d-flex">
            <i class="fas fa-calendar-alt q-c-main"></i>
            Du
            <div *ngIf="!IsDatedEditable || !displayRequiredProperties" (click)="IsDatedEditable=true"  class="ml-1" [ngClass]="[displayRequiredProperties ? 'q-dtstage-nonedit' : '']"  title="éditer la date">
              {{StageService.Stage.DateDebut|qDate}}
            </div>
            <div *ngIf="IsDatedEditable && displayRequiredProperties" class="q-dtstage-edit ml-1">
              <q-date class="w-100" [(ngValue)]="StageService.Stage.DateDebut"></q-date>
            </div>
            au
            <div *ngIf="!IsDatefEditable  || !displayRequiredProperties" (click)="IsDatefEditable=true" class="ml-1" [ngClass]="[displayRequiredProperties ? 'q-dtstage-nonedit' : '']" title="éditer la date">
              {{StageService.Stage.DateFin|qDate}}
            </div>
            <div *ngIf="IsDatefEditable && displayRequiredProperties" class="q-dtstage-edit ml-1">
              <q-date class="w-100" [(ngValue)]="StageService.Stage.DateFin"></q-date>
            </div>
          </div>
          <ng-container *ngIf="StageService.Stage.Cloture">
            <span class="q-bold q-c-danger">CLÔTURÉ</span>
          </ng-container>
        </div>

        <label [ngClass]="{'d-none': !displayRequiredProperties}" class="q-bold q-text-m q-c-light-black mb-0 mt-2">Tags</label>
        <q-tag [ngClass]="{'d-none': !displayRequiredProperties}" class="mt-2" idPere="{{StageService.Stage.Ident}}" relation="REL_BO_STAGE_BO_TAG" #tagComp></q-tag>
      </section>
    </section>
  </div>
  <div class="router-container">
    <router-outlet (activate)="OnActivateRouterOutlet($event)"></router-outlet>
  </div>
</div>




<!-- Modals BO -->
<ng-template #ModalBOStage class="modal-dialog-centered" let-modalBOStage>
  <div class="p-4">
    <button type="button" class="close d-flex justify-content-end" (click)="modalBOStage.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
    <q-bodisplay class="w-100 h-100 mb-5" [item]="modelBOStage" (sendEvent)="OnSaveBo($event); modalBOStage.close('')"></q-bodisplay>
  </div>
</ng-template>

<!-- Modals Duplication -->
<ng-template #ModalDuplicationStage class="modal-dialog-centered" let-modalDuplicationStage>
  <div class="modal-header">
    <div class="col-11 q-text-xl q-c-main">Duplication ou Fusion d'un stage</div>
    <div class="col-auto d-flex justify-content-end">
      <button type="button" class="close d-flex justify-content-end" (click)="modalDuplicationStage.close('CANCEL')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>
  <div class="p-4">
    <queoval-stage-duplication [StageIdent]="StageService.Stage.Ident" (success)="OnDuplicate($event, modalDuplicationStage)"></queoval-stage-duplication>
  </div>
</ng-template>

<!--  MODAL de validation de la suppression du stage -->
<ng-template #ModalDelete let-modalDelete class="modal-dialog-centered">
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="q-c-main text-center">Etes-vous sûr de vouloir supprimer définitivement ce stage ?</h5>
      <button type="button" class="close" (click)="modalDelete.dismiss()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="text-center">
      <div *ngIf="!lstMsgError || lstMsgError.length == 0">
        <button class="btn q-btn q-danger m-2" type="button" (click)="Delete();"
                title="Supprimer le stage">
          Supprimer
        </button>
      </div>
      <div *ngIf="lstMsgError && lstMsgError.length > 0">
        <div *ngFor="let msg of lstMsgError">
          <label class="q-c-danger text-center">{{msg}}</label>
        </div>
        <button class="btn q-btn q-danger m-2" type="button" (click)="modalDelete.dismiss()"
                title="Fermer la modale">
          Fermer
        </button>
      </div>
    </div>
  </div>
</ng-template>




